import React, { useState, forwardRef, useRef, useEffect } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import reporteConsumoStore, { tiposConsumo } from '../../../../lib/store/reporte_consumo_store';
import { MultiSelect } from 'primereact/multiselect';
import "primereact/resources/themes/lara-light-blue/theme.css";
import '../../../../styles/global.css'
import { AccionBitacora, generarObservacion, guardarBitacora } from '../../../../utils/bitacora';
import dayjs from 'dayjs';
import { VehiculosService } from '../../../../services/apiService';
import { sortBy } from 'underscore';

// 📌 Registrar la localización en español para DatePicker 
registerLocale('es', es);
setDefaultLocale('es'); //  

export const tiposConsumoMultiselect = [];

const BitacoraFiltros = ({ onGenerateReport, imprimir }) => {

    const {
        editarMostrarFiltros,
        editarSelAlertas, editarSelContactos, editarSelVehiculos, editarSelectedTipoConsumo, editarVehiculos,
        editarSelTipoConsumo, fecha, editarFecha, cargaActiva, editarCargaActiva, editarSMS, editarEmail, editarWhatsapp, editarVoz
    } = reporteConsumoStore();

    const effectRan = useRef(false);
    const now = new Date();
    const selectedDay = fecha;
    const [selDate, setSelDate] = useState(selectedDay);
    const [selectedTiposConsumo, setSelectedTiposConsumo] = useState();
    const [selectedTiposConsumoMulti, setSelectedTiposMulti] = useState(tiposConsumoMultiselect);

    const handleGenerate = () => {
        generarBitacoraReporte(AccionBitacora.Generar);
        if (cargaActiva)
            return;
        editarMostrarFiltros(false);
        editarCargaActiva(true);
        editarFecha(selDate);
        editarSelTipoConsumo(selectedTiposConsumo);
        editarSelectedTipoConsumo(selectedTiposConsumo);
        editarSMS(null);
        editarEmail(null);
        editarWhatsapp(null);
        editarVoz(null);
        editarSelAlertas([]);
        editarSelContactos([]);
        editarSelVehiculos([]);
        onGenerateReport();
    };
    useEffect(() => {
        guardarBitacora({ categoria: 'Reporte Consumos', observacion: 'Consumos', tipoAccion: AccionBitacora.EntrarReporte });
        window.guardarBitacoraPrint = () => {
            generarBitacoraReporte(AccionBitacora.Imprimir);
        };
        window.guardarBitacoraExport = () => {
            generarBitacoraReporte(AccionBitacora.Exportar);
        };
        loadVehiculos();
    }, []);
    const filtrosGenerarRef = useRef();
    const generarBitacoraReporte = (accion) => {
        if (accion === AccionBitacora.Generar) {
            let fecha_inicio = dayjs(selDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let hora_inicio = dayjs(selDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
            let fecha_fin = dayjs(selDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let dataGrupos = [];
            let dataVehiculos = [];
            let dataAlertas = [];
            let dataConsumos = (selectedTiposConsumo || []);
            let mes = dayjs(selDate.getTime()).tz(dayjs.tz.guess()).format("MMMM");
            filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas, dataConsumos, mes };
        }
        guardarBitacora({
            categoria: 'Reporte Consumos',
            observacion: generarObservacion(
                'Consumos',
                {
                    fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
                    hora_inicio: filtrosGenerarRef.current.hora_inicio,
                    fecha_fin: filtrosGenerarRef.current.fecha_fin,
                    grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
                    vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
                    tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
                    consumos: filtrosGenerarRef.current.dataConsumos.map(w => w.label).join(', '),
                    mes: filtrosGenerarRef.current.mes,
                }
            ),
            tipoAccion: accion
        });
    }

    const loadVehiculos = async () => {
        try {
            const response = await VehiculosService.getVehiculos();

            if (response && response.statusCode === 200) {
                const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() });

                const vehiculosData = _vehiculos.map(vehiculo => ({
                    value: vehiculo.uid_vehiculo ?? "",
                    label: `${vehiculo.no_economico ?? ""} / ${vehiculo.alias ?? ""}`,
                    uid_grupo: vehiculo.uid_grupo ?? "",
                    idvehiculo: vehiculo.id_analitic ?? "",
                    no_economico: vehiculo.no_economico ?? "",
                    alias: `${vehiculo.alias ?? ""}`,
                    tipo_vehiculo: vehiculo.tipo_vehiculo ?? "",
                    color_vehiculo: vehiculo.color_vehiculo ?? ""
                }));
                editarVehiculos(vehiculosData);
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        }
    };

    useEffect(() => {
        if (effectRan.current) return;
        effectRan.current = true;
        //handleGenerate();
    }, []);

    useEffect(() => {

        //Obtiene las opciones seleccionadas
        const selectedNews = tiposConsumo.filter(item => selectedTiposConsumoMulti.includes(item.value))

        //Inserta la nueva data seleccionada
        setSelectedTiposConsumo(selectedNews);
        editarSelTipoConsumo(selectedNews);

    }, [selectedTiposConsumoMulti]);

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control ref={ref} onClick={onClick} value={value} onChange={() => { }} />
        </div>
    ));

    // 📌 Personalizar la vista del Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '34px',
            overflow: 'hidden'
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '34px',
            overflow: 'hidden'
        })
    };

    // 📌 Método para manejar cualquier Select
    const handleSelectChange = (selected, options, setSelected) => {

        const allSelected = selected.some(option => option.value === 'all');

        const todasLasOpciones = options.flatMap(grupo => grupo.options || grupo);

        if (allSelected) {
            if (selected.length === todasLasOpciones.length + 1) { // 🔹 Se suma 1 por la opción "Seleccionar todos"
                setSelected([]); // 🔹 Deseleccionar todo correctamente
            } else {
                setSelected(todasLasOpciones); // 🔹 Seleccionar todas las opciones ignorando los agrupadores
                editarSelTipoConsumo(todasLasOpciones);
            }
        } else {
            setSelected(selected);
            editarSelTipoConsumo(selected);
        }
    };

    return (
        <div>
            <div id="filter-collapse">
                <Row>
                    <Col md={3} xs={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Tipo de consumo</Form.Label>

                            <MultiSelect
                                className="multiselect-ul w-full md:w-20rem"
                                value={selectedTiposConsumoMulti}
                                onChange={(selected) => setSelectedTiposMulti(selected.value)}
                                options={[
                                    ...tiposConsumo
                                ]}
                                optionLabel="label"
                                filter
                                placeholder="Seleccione un tipo"
                                maxSelectedLabels={2}
                                selectedItemsLabel={`${(selectedTiposConsumoMulti || []).length} tipos seleccionados`}
                            />

                            {/* <Select
                                key={'tipo-selector'}
                                closeMenuOnSelect={false}
                                options={[
                                    ...(selectedTiposConsumo.length !== tiposConsumo.length
                                        ? [{ value: 'all', label: 'Seleccionar todos' }]
                                        : [{ value: 'all', label: 'Deseleccionar todos' }]
                                    ),
                                    ...tiposConsumo
                                ]}
                                classNamePrefix="react-select"
                                placeholder='Seleccionar...'
                                value={selectedTiposConsumo}
                                onChange={(selected) => handleSelectChange(selected, tiposConsumo, setSelectedTiposConsumo)}
                                isMulti
                                styles={customStyles}
                            /> */}
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Seleccionar un mes</Form.Label>
                            <DatePicker
                                selected={selDate}
                                maxDate={now}
                                onChange={(date) => {
                                    setSelDate(date)
                                }}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="MMMM"
                                showMonthYearPicker
                                fixedHeight
                                locale="es" // 📌 Localización en español
                                timeCaption="Hora" // 
                            />
                        </Form.Group>
                    </Col>

                    <Col md={2} xs={4} className="pe-3">
                        <div className="d-flex justify-content-center mt-4">
                            <Button
                                variant="primary"
                                onClick={handleGenerate}
                                className="w-100"
                                disabled={selectedTiposConsumoMulti.length === 0}
                            >
                                Generar
                            </Button>
                        </div>
                    </Col>
                    <Col md={2} xs={4}>
                        <div className="print-report d-flex mt-4" style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* </Collapse> */}
        </div>
    );
};

export default BitacoraFiltros;